import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/logo_project.png";
import "./CodigoProducto.css";
import Swal from "sweetalert2";
import ScaleLoader from "react-spinners/ScaleLoader";

const CodigoProducto = () => {
    const navigate = useNavigate();
    const [codigoProducto, setCodigoProducto] = useState("");
    const [isNavigating, setIsNavigating] = useState(false);

    const handleIrClick = async () => {
        if(codigoProducto.trim() !== ""){
            setIsNavigating(true); 
            sessionStorage.setItem("CodigoProducto", codigoProducto);
            await navigate("/"); 
        } else {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ingrese el código de producto",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#2f9f91"
            });
        }
        setIsNavigating(false); 
    };

    const handleCodigoProductoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCodigoProducto(event.target.value);
    };
    // Link deshabilitado temporalmente
    // const handlePowerAppClick = () => {
    //     window.location.href = " https://apps.powerapps.com/play/f9f30cb2-f6de-4d56-b05b-21e99fc26896?tenantId=5368fc5a-2692-4a6a-b226-e2802e94e22b&source=portal ";
    // };

    return (
        <div className="auth-container">
            <div className="auth-background"></div>
            <div className="auth-container-form">
                <div className="container-logo">
                    <img src={logo} alt="" className="logo" />
                </div>
                <div className="form-container">
                    <label htmlFor="">Ingrese el código del producto</label>
                    <input type="text" name="codigoProducto" id="codigoProducto" value={codigoProducto} onChange={handleCodigoProductoChange} />
                    {isNavigating ? ( 
                        <ScaleLoader color="#2f9f91" height={15} width={2} radius={2} margin={2} />
                    ) : (
                        <input type="submit" value="Ir" onClick={handleIrClick} />
                    )}
                    {/*
                    <div>
                        <label htmlFor="">Gestión Comercial</label>
                        <input type="submit" value="Power App" onClick={handlePowerAppClick}/>
                    </div>
                    */}
                </div>
            </div>
        </div>
    );
};

export default CodigoProducto;
